module.exports = __webpack_public_path__ + "static/media/cafe24-stock.cad17d35.png";